/******************************************************
 *                  LAZY STYLE DIRECTIVE
 *
 * This directive looks for the url display the client logo.
 * Used to chart the app for specific customers
 ****************************************cd ****************/

"use strict";

angular.module("app").directive("customLogo",function () {
	return {
		restrict: "E",
		link: function (scope, element) {

			var tag = document.createElement("img");
			tag.src = "assets/img/lumidata-logo.png";
			element.append(tag);

		}
	};
});